export const views = ['month', 'week', 'day'];
